import { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import TagComponent from './Tag';
import styled from 'styled-components';

const useStyles = makeStyles(() => ({
	textField: {
		'&.MuiFilledInput-root': {
			padding: '26px 65px 10px 9px',
		},
	},
}));

const TagContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
`;

export const TagList = (props) => {
	const classes = useStyles();
	const { options, onSelectedOptionsChange, value, isMultiple = false, filterSelectedOptions = false } = props;

	const [selectedValue, setSelectedValue] = useState(isMultiple ? [] : null);
	
	useEffect(() => {
		if (value && value.length > 0) {
			setSelectedValue(!isMultiple ? value[0] : value);
		}
	}, [props, isMultiple, value]);

	const changeHandler = (event, newValue) => {
		onSelectedOptionsChange(newValue);
		setSelectedValue(newValue);
	};
	return (
		<Autocomplete
			multiple={isMultiple}
			id="autocomplete-tag-select"
			key="tag-select-autocomplete"
			options={options}
			getOptionLabel={(option) => option.name}
			value={selectedValue}
			onChange={changeHandler}
			filterSelectedOptions={filterSelectedOptions}
			renderTags={(value, getTagProps) => (
				<TagContainer>
					{value.map((option, index) => (
						<TagComponent
							{...getTagProps({ index })}
							tag={option}
							forAutoComplete={true}
						/>
					))}
				</TagContainer>
			)}
			renderInput={(params) => (
				<TextField
					variant="filled"
					{...params}
					InputProps={{ ...params.InputProps, className: classes.textField }}
					label="Product Label"
				/>
			)}
		/>
	);
};
